// extracted by mini-css-extract-plugin
export default {"ProviderLogo":"ProviderLogo-module__ProviderLogo__yWtK5Mr"};